import React, { useState } from "react";
import { toast } from "react-toastify";

const WaitListModal = ({ token, userDetails, closeModal }) => {
  const [editedData, setEditedData] = useState({ ...userDetails });
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setEditedData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!editedData.name || !editedData.email) {
      toast.error("Name and email cannot be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    const formData = new FormData();
    formData.append("name", editedData.name);
    formData.append("email", editedData.email);

    try {
      const response = await fetch(`${baseUrl}/api/waitlist/join`, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        toast.success("Waitlist joined successfully", {
          position: toast.POSITION.TOP_RIGHT,
        });
        closeModal();
      } else if (response.status === 500) {
        toast.error("Internal server error. Please try again later.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        const data = await response.json();
        console.log(data);
        toast.error(data.error.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      console.error("An error occurred while joining waitlist:", error);
      toast.error("An error occurred. Please try again.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  return (
    <div className="fixed top-16 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-6 lg:w-1/3 rounded-md shadow-md overflow-y-auto max-h-full">
        <h2 className="text-lg font-semibold mb-4">
          Be amongst the first to use MagicAI.
        </h2>
        <form onSubmit={handleSubmit}>
          {/* Name */}
          <div className="mb-4">
            <label className="block mb-1 font-medium">Name</label>
            <input
              type="text"
              name="name"
              value={editedData.name}
              onChange={handleInputChange}
              placeholder="Enter your name"
              className="w-full rounded-md border px-3 py-2"
            />
          </div>

          {/* Email */}
          <div className="mb-4">
            <label className="block mb-1 font-medium">Email</label>
            <input
              type="email"
              name="email"
              value={editedData.email}
              onChange={handleInputChange}
              placeholder="Enter your email"
              className="w-full rounded-md border px-3 py-2"
            />
          </div>
          <div className="flex justify-end">
            <button
              type="button"
              className="bg-gray-300 px-4 py-2 rounded-md mr-2"
              onClick={closeModal}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
              onClick={handleSubmit}
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default WaitListModal;
